import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function updateBonifications(body) {
  const response = await axios.put(`${REACT_APP_API}/bonifications/createOrUpdateBonification`, body)
  
  return response?.data?.data
}
